// src/stores/useFeatureColorStore.js
//
// Session-only per-type color overrides for the FEATURES-tab vector_assets
// layers. v1: NOT persisted — resets to the curated palette defaults on reload.
// Effective color = overrides[type] ?? palette ?? fallback
// (see constants/featureColors.js: effectiveFeatureColor).

import { create } from "zustand";

export const useFeatureColorStore = create((set) => ({
  overrides: {}, // asset_type -> hex (#rrggbb)

  setColor: (type, hex) =>
    set((s) => ({ overrides: { ...s.overrides, [type]: hex } })),

  resetColor: (type) =>
    set((s) => {
      if (!(type in s.overrides)) return s;
      const next = { ...s.overrides };
      delete next[type];
      return { overrides: next };
    }),
}));
